<template>
  <div>
    <b-row>
      <b-col>
        <chat-messages
            :profile="profile"
            :message-box-ref-id="messageBoxRefId"
            :messages="messages"
        />
        <chat-message-box
            :message-box="messagesBox"
            @submit-text="handleSubmitText"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import firebase from "firebase";
import ChatMessages from "./messages";
import ChatMessageBox from "./messageBox";

export default {
  name: "Sessions_Chat",
  components: {
    ChatMessages,
    ChatMessageBox
  },
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  computed: {},
  methods: {
    setupChat(){
      ///Create sample messages for local- doe sno
      this.messagesBox = this.$refs[this.messageBoxRefId];
      const db = firebase.firestore(); //Move to single place
      let uid = this.profile.userId;

      this.collectionRef = db.collection(`users/${uid}/lists/__sessions/messages_${this.sessionId}`);
      this.unsub = this.collectionRef.onSnapshot((snapshot) => {
        this.messages = [];
        snapshot.docs.forEach((doc) => {
              this.messages.push({...doc.data(), id: doc.id});
            }
        )
        //this.scrollToBottom();
      });
    },
    handleSubmitText(text) {
      //CReate sample messages for local
      this.text='';
      this.messages.push(this.createTempPromptMessage(text, this.profile && this.profile.userId ?  this.profile.userId : null));

      if (this.collectionRef) {
        if (text && text.length > 0) {
          this.collectionRef
              .add({
                _created_at: new Date(),
                _created_by: this.profile && this.profile.userId ? this.profile.userId : null,
                prompt: text
              });
        }
      } else{
        //Local
        let localText = 'This is a sample of the chat and how it looks and sounds. You can change images and colors';
        this.messages.push(this.createTempPromptMessage(localText, 'local'));

      }
    },
    createTempPromptMessage(message, userId){
      return {
        _created_at: new Date(),
        _created_by: userId,
        prompt: message
      }
    },
  },
  data() {
    return {
      sessionId: this.session && this.session.id ? this.session.id : null,
      messages: [],
      messagesBox: null,
      collectionRef: null,
      text:'',
      textMax:500,
      messagePlaceHolder:"Enter Something ...",
      messageRows:2,
      messageRowsMax:5,
      messageBoxRefId:'message-box',
    };
  }
};
</script>

<style lang="scss" scoped>

</style>
